import { FileExtension } from './file-extension';

export class FileMetadata {
  constructor(
    public fileHash: string,
    public title: string,
    public uploadDate: Date,
    public extension: FileExtension
  ) {}
}
